import { render, staticRenderFns } from "./SearchResultItemPostFooter.vue?vue&type=template&id=1e1a7306&scoped=true&"
import script from "./SearchResultItemPostFooter.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemPostFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemPostFooter.vue?vue&type=style&index=0&id=1e1a7306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a7306",
  null
  
)

export default component.exports